/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import classNames from "classnames";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import RadioList from "./content";
import Footer from "./footer";

/* Styles */
import styles from "./styles";

const GeneralRadioListModal = ({
  isOpen,
  onClose,
  onConfirm,
  options,
  icon,
  title,
  description,
  confirmText,
  cancelText,
  initialValue = null,
  className,
  radioListButtonSpinner,
  confirmDisabled,
  getValue = (item) => item,
  getLabel = (item) => item,
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const [selected, setSelected] = useState(initialValue);

  useEffect(() => {
    if (!isOpen) {
      setSelected(initialValue);
    }
  }, [isOpen, initialValue]);

  const handleConfirm = () => {
    onConfirm(selected);
  };

  return (
    <UCModal
      className={classNames(classes.generalRadioListModalStyle, className)}
      showModal={isOpen}
      setShowModal={onClose}
      modalIcon={icon}
      modalTitle={title}
      modalDescription={description}
      modalContent={
        <RadioList
          options={options}
          selected={selected}
          onChange={setSelected}
          getValue={getValue}
          getLabel={getLabel}
        />
      }
      modalFooter={
        <Footer
          onCancel={onClose}
          onConfirm={handleConfirm}
          confirmText={confirmText}
          cancelText={cancelText}
          isConfirmDisabled={confirmDisabled ? confirmDisabled(selected) : false}
          radioListButtonSpinner={radioListButtonSpinner}
        />
      }
    />
  );
};

export default GeneralRadioListModal;